/* ------------------------------------------------------------------------ */
/*		File: cmpDetailResource.tsx                                         */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { ICard } from "./cmpCardDetail.d";
import { getImage } from "../GenericComponents/functions";
import "./cmpCardDetail.css";

/* ------------------------------------------------------------------------ */


const CardDetail: React.FC<ICard> = ({card}: ICard) => {
    return (
        <div className="card_detail">
            <div className="card_detail_content_one">
                <div className="card_detail_content_one_title">
                    <div className={`square_${card.type}`}/>
                    {card.title}
                </div>
                <div className="card_detail_content_one_date">
                    <div className="icon">
                        <img src={getImage("clock.svg")} alt="clock.svg"/>
                    </div>
                    {new Date(card.createdAt!).toLocaleString()}
                </div>
            </div>
            <div 
                className="card_detail_text"
                dangerouslySetInnerHTML={{ __html: card.text! }}
            />
        </div>
    );
};
  
export default CardDetail; 